class Elementor_Item_Carousel {
    static instance;

    static getInstance() {
        if (!Elementor_Item_Carousel.instance) {
            Elementor_Item_Carousel.instance = new Elementor_Item_Carousel();
        }
        return Elementor_Item_Carousel.instance;
    }

    constructor() {
        $(window).on('elementor/frontend/init', () => {
            this.init();
        });
    }

    init() {
        elementorFrontend.hooks.addAction('frontend/element_ready/opal-item-box.default', ($scope) => {
            let $carousel = $scope.find('.owl-carousel');
            if ($carousel.length > 0) {
                let data = $carousel.data('settings');
                $carousel.owlCarousel(Elementor_Carousel.setupData(data));
            }

        });
    }
}


Elementor_Item_Carousel.getInstance();